import { useEffect } from "react";

export default function useSEO({ title, description, canonical } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
    if (canonical) {
      const l = document.querySelector('link[rel="canonical"]');
      if (l) l.setAttribute("href", canonical);
    }
  }, [title, description, canonical]);
}
